import { Schema } from "rsuite";

const { Model, Types } = Schema;

export type SuperAdminAddFormType = {
  superAdminId?: string;
  email?: string;
  userName?: string;
  password?: string;
  confPassword?: string;
  firstName?: string;
  lastName?: string;
  companyName?: string;
  countryId?: string;
  address?: string;
  state?: string;
  country?: string;
};

export const SuperAdminAddFormSchema = Model({
  email: Types.StringType().isRequired("Email is required"),
  userName: Types.StringType().isRequired("UserName is required"),
  password: Types.StringType().isRequired("Password is required"),
  confPassword: Types.StringType().isRequired("Please confirm your password"),
  firstName: Types.StringType().isRequired("First name is required"),
  lastName: Types.StringType().isRequired("Last name is required"),
  companyName: Types.StringType().isRequired("Company name is required"),
  address: Types.StringType().isRequired("Address is required"),
  state: Types.StringType().isRequired("State is required"),
  countryId: Types.StringType().isRequired("Country is required"),
});

export const SuperAdminAddDefaultValues: SuperAdminAddFormType = {
  superAdminId: "",
  email: "",
  userName: "",
  password: "",
  confPassword: "",
  firstName: "",
  lastName: "",
  companyName: "",
  address: "",
  state: "",
  countryId: "",
};
